import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "./state";
import { IFreehandShapeUponCreation, IZoneMapLocationUponCreation } from "./types";
import { ZoneEntity, ZoneType } from "@src/core/features";

export default createSlice({
  name: 'ZonesSlice',
  initialState,
  reducers: {
    setCollapse: (state, action: { payload: { [ZoneType.TEMPORARY]: boolean; [ZoneType.PERMANENT]: boolean } }) => {
      state.collapse = action.payload;
    },
    setSelectedZone: (state, action: { payload: ZoneEntity | null }) => {
      state.selectedZone = action.payload;
    },
    setHoveredSafeLandZoneId: (state, action: PayloadAction<number | null>) => {
      state.hoveredSafeLandZoneId = action.payload;
    },
    toggleCollapse: (state, action: { payload: ZoneType }) => {
      const zoneType = action.payload;
      state.collapse[zoneType] = !state.collapse[zoneType];
    },
    setZoneMapLocationUponCreation: (state, action: PayloadAction<IZoneMapLocationUponCreation | null>) => {
      state.zoneMapLocationUponCreation = action.payload ?{
        ...action.payload,
      } : null;
    },
    setFreehandShapeUponCreation: (state, action: PayloadAction<IFreehandShapeUponCreation | null>) => {
      state.freehandShapeUponCreation = action.payload ?{
        ...action.payload,
      } : null;
    },
  }});
